<template>
    <div>
        <label :for="name">
            {{displayName}}
        </label>
        <input type="hidden" :name="`${name}-html`" :value="html">
        <input type="hidden" :name="`${name}-quill`" :value="quillContents">
        <div
            :name="name" 
            :id="name"
            ref="quill-input"
        ></div>
    </div>
</template>

<script>
    import _ from 'lodash'
    
    export default {
      props: [
          'name',
          'displayName',
          'placeholder',
          'value',
          'editorBackground',
          'editorOverlay',
      ],
      data() {return {
          quill: null,
          quillContents: null,
          html: null,
      }},
      mounted() {
          
        this.quill = new Quill(this.$refs['quill-input'], {
            modules: {
                toolbar: [
                    [
                        { 'header' : [1, 2, 3, 4, 5, 6, false] },
                        { 'size': ['small', false, 'large', 'huge'] },
                        { 'font': [] },
                    ],
                    ['bold', 'italic', 'underline', {color: []}, { align: ['', 'right', 'center']}],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    ['link', 'clean'],
                ]
            },
            theme: 'snow',
        });

        this.quill.getModule('toolbar').addHandler('image', this.selectFile)
        this.quill.on('editor-change', _.debounce(this.editorChange, 200));
        if (typeof this.value === 'string' && this.value !== '') {
            this.quill.setContents(JSON.parse(this.value))
        } else {
            this.quill.setContents(this.value || {})
        }

        if (this.editorOverlay) {
            this.quill.container.children[0].style.cssText = `background: ${this.editorOverlay}; padding: 50px;`
        }
        if (this.editorBackground) {
            this.quill.container.style.cssText = `background: url(${this.editorBackground}) no-repeat center center;`
        }
      },
      watch: {
          editorBackground() {
                if (this.editorBackground) {
                    this.quill.container.style.cssText = `background: url(${this.editorBackground}) no-repeat center center;`
                    return
                }
                this.quill.container.style.cssText = `background: none;`

          },
          editorOverlay() {
              if (this.editorOverlay) {
                this.quill.container.children[0].style.cssText = `background: ${this.editorOverlay}; padding: 50px;`
              }
          },
      },
      methods: {
          editorChange (eventName, ...args) {
            if (eventName === 'text-change' || eventName === 'selection-change') {
                this.html = this.quill.root.innerHTML
                this.quillContents = JSON.stringify(this.quill.getContents())
                this.$emit('quillChanged', this.html, this.quillContents)
            }
          },

      },
    }
</script>
